import React, { useEffect, useRef, useState } from "react"
import Stats2 from "../../UI/Stats/Stats2"
import classes from './Overview.module.css'
import { alpha, useScrollTrigger } from "@mui/material"
import { checkAccessRestrictions, checkSiteConfig, getLiveViewCameras, listPartneredArcs, setArc, setScheduleOnly, setSiteActive, setsiteActive, setSiteLiveView, setSiteNotififcations, updateSiteDetails, getVirtualRelationshipsAPI, updateGateway, updateSensor, updateLockDetails, setEmbeddedURL } from "../../../Api Methods/Api"
import useData from "rsuite/esm/InputPicker/hooks/useData"
import { useDispatch, useSelector } from "react-redux"
import { InputSwitch } from "primereact/inputswitch"
import Button1 from "../../UI/Button/Button1"
import Modal from "../../Modal/Modal"
import { Toast } from "primereact/toast"
import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { Calendar } from "primereact/calendar"
import { format } from "date-fns"
import Lottie from "lottie-react"
import areYouSureAnim from '../../../assets/animations/areYouSure.json'

const Overview = ({device, setShowChangeGroup, setShowChangeCCTV, setShowChangeName, setShowChangePortalName, setShowSuspendSite, groups, apiData, successModal, successModalWithReload, errorModal, setShowChangeSerialNumber, userCount, isCollapsed, pendingActive, setPendingActive}) => {
    const dispatch = useDispatch();
    const options = {
        year: 'numeric',
        month: 'long', 
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        seconds: "2-digit",
        hour12: false     
    };
    const [siteData, setSiteData] = useState(device[1])
    console.log(siteData);
    const group = siteData.name
    const macAddress = siteData.mac
    const siteID = siteData.key
    const sitetype = siteData.type
    const ipAddress = siteData.ip
    const uuid = siteData.uuid
    const createdBy = siteData.fullName ?? null
    var IP = ""
    const online = siteData.online === "YES" ? "Online" : "Offline"
    const serialNumber = siteData.subGroup === "" ? "Not serialised" : siteData.subGroup
    const outputs = device[0].OutputPins 
    const inputs = device[0].InputPins
    const pins = outputs.concat(inputs)
    const [notificationsEnabled, setNotificationsEnabled] = useState(pins.some(pin => pin.notificationActive == 1))
    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingArc, setIsLoadingArc] = useState(true)
    const [isLoadingRestriction, setIsLoadingRestriction] = useState(true)
    const creation = new Date(siteData.created)
    const creationDate = creation.toLocaleString('en-US', options)

    const lastUpdate = new Date(siteData.lastLoggedIn)
    const lastUpdateDate = lastUpdate.toLocaleString('en-US', options)

    const suspended = siteData.status === "available" ? "No" : "Yes"
    const portalSiteName = siteData.tag === "" ? "No name set" : siteData.tag
    const embeddedURL = (siteData.embeddedURL != "" && siteData.embeddedURL != null) ? siteData.embeddedURL : ""
    const embeddedURLTitle = (siteData.embeddedURLTitle != "" && siteData.embeddedURLTitle != null)? siteData.embeddedURLTitle : "Not set"

    const firmware = siteData.firmware
    const firmwareSplit = firmware.split('.')
    const firmwareMajor = firmwareSplit[0]
    const firmwareMinor = firmwareSplit[1]
    let type = siteData.type == ("CC" || "S") ? "Virtual iON" : "iON"
    
    const showMac = siteData.type != "CC" && siteData.type != "S"
    let showIP = siteData.type != 'S' || true
    const [showCCTVIntegration, setShowCCTVIntegration] = useState(true)
    const [camectIntegrationType, setCamectIntegrationType] = useState("")
    const myAppSiteName = siteData.deviceName == '' ? "Not added to mobile app" : siteData.deviceName

    const [monitoredBy, setMonitoredBy] = useState("")
    const [monitoredByOptions, setMonitoredByOptions] = useState([])
    const [showMonitoredByDropdown, setShowMonitoredByDropdown] = useState(false)
    const [showMonitoredBy, setShowMonitoredBy] = useState(false)
    const [_supportsCamect, _setSupportsCamect] = useState("")
    const [_supportsMonitoredBy, _setSupportsMonitoredBy] = useState("")

    const [accessRestrictions, setAccessRestrictions] = useState("None")

    const [modalTitle, setModalTitle] = useState("Generate Access")
    
    const [modalComponent, setModalComponent] = useState()
    const [modalPageIndex, setModalPageIndex] = useState(null);

    const ModalDialog = useRef();
    const ClearStatesChildComponetRef = useRef();

    const [switchState, setSwitchState] = useState(siteData.active)
    const [liveViewSwitchState, setLiveViewSwitchState] = useState(siteData.liveViewEnabled)
    const [scheduleOnlySwitchState, setScheduleOnlySwitchState] = useState(siteData.scheduleOnly)
    const [snapshotEnabledSwitchState, setSnapshotEnabledSwitchState] = useState(siteData.snapshotEnabled)

    const [liveViewCameras, setLiveViewCameras] = useState([]);
    const [liveViewCameraCount, setLiveViewCameraCount] = useState(0);

    const portalName = portalSiteName !== "No name set" ? `${portalSiteName} - ${siteID}` : siteID

    const [countryCode, setCountryCode] = useState(siteData.country_code || "Not set")
    const countryCodeOptions = [
      { code: 'GB', name: 'United Kingdom' },
      { code: 'IE', name: 'Ireland' },
      { code: 'US', name: 'United States' },
      { code: 'CA', name: 'Canada' },
      { code: 'ZA', name: 'South Africa' },
      { code: 'AF', name: 'Afghanistan' },
      { code: 'AL', name: 'Albania' },
      { code: 'DZ', name: 'Algeria' },
      { code: 'AR', name: 'Argentina' },
      { code: 'AU', name: 'Australia' },
      { code: 'AT', name: 'Austria' },
      { code: 'BE', name: 'Belgium' },
      { code: 'BR', name: 'Brazil' },
      { code: 'BG', name: 'Bulgaria' },
      { code: 'CL', name: 'Chile' },
      { code: 'CN', name: 'China' },
      { code: 'CO', name: 'Colombia' },
      { code: 'HR', name: 'Croatia' },
      { code: 'CY', name: 'Cyprus' },
      { code: 'CZ', name: 'Czech Republic' },
      { code: 'DK', name: 'Denmark' },
      { code: 'EE', name: 'Estonia' },
      { code: 'FI', name: 'Finland' },
      { code: 'FR', name: 'France' },
      { code: 'DE', name: 'Germany' },
      { code: 'GR', name: 'Greece' },
      { code: 'HU', name: 'Hungary' },
      { code: 'IS', name: 'Iceland' },
      { code: 'IN', name: 'India' },
      { code: 'ID', name: 'Indonesia' },
      { code: 'IL', name: 'Israel' },
      { code: 'IT', name: 'Italy' },
      { code: 'JP', name: 'Japan' },
      { code: 'KE', name: 'Kenya' },
      { code: 'LV', name: 'Latvia' },
      { code: 'LT', name: 'Lithuania' },
      { code: 'LU', name: 'Luxembourg' },
      { code: 'MY', name: 'Malaysia' },
      { code: 'MT', name: 'Malta' },
      { code: 'MX', name: 'Mexico' },
      { code: 'NL', name: 'Netherlands' },
      { code: 'NZ', name: 'New Zealand' },
      { code: 'NO', name: 'Norway' },
      { code: 'PL', name: 'Poland' },
      { code: 'PT', name: 'Portugal' },
      { code: 'RO', name: 'Romania' },
      { code: 'SA', name: 'Saudi Arabia' },
      { code: 'SG', name: 'Singapore' },
      { code: 'SK', name: 'Slovakia' },
      { code: 'SI', name: 'Slovenia' },
      { code: 'KR', name: 'South Korea' },
      { code: 'ES', name: 'Spain' },
      { code: 'SE', name: 'Sweden' },
      { code: 'CH', name: 'Switzerland' },
      { code: 'TH', name: 'Thailand' },
      { code: 'TR', name: 'Turkey' },
      { code: 'UA', name: 'Ukraine' },
      { code: 'AE', name: 'United Arab Emirates' },
      { code: 'VN', name: 'Vietnam' }
    ];
    const [showCountryDropdown, setShowCountryDropdown] = useState(false)

    const [siteType, setSiteType] = useState(siteData.site_type || "Not set")
    const siteTypeOptions = [
      { key: 'RESIDENTIAL', label: 'Residential' },
      { key: 'OFFICE', label: 'Office' },
      { key: 'COMMERCIAL', label: 'Commercial' },
      { key: 'INDUSTRIAL', label: 'Industrial' },
      { key: 'CONSTRUCTION', label: 'Construction' },
      { key: 'WAREHOUSE', label: 'Warehouse / Storage' },
      { key: 'EDUCATION', label: 'Education' },
      { key: 'HEALTHCARE', label: 'Healthcare' },
      { key: 'PUBLIC', label: 'Public / Government' },
      { key: 'VACANT', label: 'Vacant property' },
      { key: 'UTILITY', label: 'Utility / Infrastructure' },
      { key: 'OTHER', label: 'Other' }
    ];
    const [showSiteTypeDropdown, setShowSiteTypeDropdown] = useState(false)

    const [showChangeNotificationState, setShowChangeNotificationState] = useState(false)

    const [showSuspendPopup, setShowSuspendPopup] = useState(false)

    const [showEmbeddedURLDialog, setShowEmbeddedURLDialog] = useState(false)
    const [editEmbeddedURL, setEditEmbeddedURL] = useState("")
    const [editEmbeddedURLTitle, setEditEmbeddedURLTitle] = useState("")

    const [showImmixDialog, setShowImmixDialog] = useState(false)
    const [pendingArc, setPendingArc] = useState(null)
    const [smtpToEmail, setSmtpToEmail] = useState((siteData.smtpToAddress != "" && siteData.smtpToAddress != null)? siteData.smtpToAddress : "")
    const [smtpFromEmail, setSmtpFromEmail] = useState((siteData.smtpFromAddress != "" && siteData.smtpFromAddress != null)? siteData.smtpFromAddress : "")
    const [smtpUsername, setSmtpUsername] = useState((siteData.smtpUsername != "" && siteData.smtpUsername != null)? siteData.smtpUsername : "")
    const [smtpPassword, setSmtpPassword] = useState((siteData.smtpPassword != "" && siteData.smtpPassword != null)? siteData.smtpPassword : "")

    const [showImmixAddressDialog, setShowImmixAddressDialog] = useState(false)
    const [immixAddress, setImmixAddress] = useState((siteData.immixAddress != "" && siteData.immixAddress != null)? siteData.immixAddress : "")

    const companyName = useSelector(state => state.auth.companyName);
    const role = useSelector(state => state.auth.role);
    const isAllowed = companyName == "EyeSpyFX" || companyName == "KNOWIO" ? true : false
    const isCustomerBillingAllowed = companyName === "EyeSpyFX" || companyName === "RE:SURE"
    const isEyeSpyFXOnly = companyName === "EyeSpyFX"
    //const isAllowed = false
    const toast = useRef(null);

    const billingOptions = ["Monthly", "Annually"]

    const [changeBillable, setChangeBillable] = useState(false)
    const [changeBilledTo, setChangeBilledTo] = useState(false)
    const [changeBillingFrequency, setChangeBillingFrequency] = useState(false)
    const [changeDateOfFirstInvoice, setChangeDateOfFirstInvoice] = useState(false)
    const [changeDateOfLastInvoice, setChangeDateOfLastInvoice] = useState(false)
    const [changeDateMadeActive, setChangeDateMadeActive] = useState(false)
    const [changeCustomerBilledTo, setChangeCustomerBilledTo] = useState(false)
    const [newBilledToGroupName, setNewBilledToGroupName] = useState(groups?.find(g => g.id === siteData.billedToGID)?.name || "")
    const [newCustomerBilledToGroupName, setNewCustomerBilledToGroupName] = useState(groups?.find(g => g.id === siteData.customerBilledToGID)?.name || "")
    const [newBillingFrequency, setNewBillingFrequency] = useState("")
    const [newDateOfFirstInvoice, setNewDateOfFirstInvoice] = useState("")
    const [newDateOfLastInvoice, setNewDateOfLastInvoice] = useState("")
    const [newDateMadeActive, setNewDateMadeActive] = useState("")
    const [unauthotisedClick, setUnauthorisedClick] = useState(false)

    const BILLING_PROPAGATION_COLUMNS = new Set(['billable', 'billedToGID', 'billingFrequency', 'firstInvoiceDate', 'lastInvoiceDate'])

    const [connectedDevices, setConnectedDevices] = useState(null)
    const [showPropagateDialog, setShowPropagateDialog] = useState(false)
    const [pendingPropagation, setPendingPropagation] = useState(null)
    const [isPropagating, setIsPropagating] = useState(false)


    const fetchConnectedDevices = async () => {
        const response = await getVirtualRelationshipsAPI(apiData, uuid)
        const relationships = response?.[0] ?? {}
        const iglooLocksRaw = await Promise.resolve(device[0].singleDeviceSettingData.iglooLocks)
        const devices = {
            gateways: relationships.gateways || [],
            sensors: [...(relationships.sigfox || []), ...(relationships.efento || []), ...(relationships.teltonika || [])],
            iglooLocks: Array.isArray(iglooLocksRaw) ? iglooLocksRaw : [],
        }
        setConnectedDevices(devices)
        return devices
    }

    const connectedDeviceCount = (devices) =>
        (devices?.gateways?.length ?? 0) +
        (devices?.sensors?.length ?? 0) +
        (devices?.iglooLocks?.length ?? 0)

    const offerPropagation = async (columnName, newValue) => {
        if (!BILLING_PROPAGATION_COLUMNS.has(columnName)) return
        const devices = connectedDevices ?? await fetchConnectedDevices()
        if (connectedDeviceCount(devices) > 0) {
            setPendingPropagation({ columnName, newValue })
            setShowPropagateDialog(true)
        }
    }

    const propagateBillingChange = async () => {
        if (!pendingPropagation || !connectedDevices) return
        const { columnName, newValue } = pendingPropagation
        setShowPropagateDialog(false)
        setIsPropagating(true)

        const calls = [
            ...connectedDevices.gateways.map(gw =>
                updateGateway(apiData, { gatewayIMEI: gw.IMEI, columnName, newValue }, dispatch)
            ),
            ...connectedDevices.sensors
                .filter(s => s.sensorID)
                .map(s => updateSensor(apiData, { sensorID: s.sensorID, columnName, newValue }, dispatch)),
            ...connectedDevices.iglooLocks
                .filter(l => l.lockID)
                .map(l => updateLockDetails(apiData, { lockID: l.lockID, columnName, newValue }, dispatch)),
        ]

        await Promise.all(calls)
        setIsPropagating(false)
        setPendingPropagation(null)
        successModal(`Billing updated on ${connectedDeviceCount(connectedDevices)} connected device${connectedDeviceCount(connectedDevices) !== 1 ? 's' : ''}`)
    }

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        };
    }

    useEffect(() => {
      const CheckSiteConfig = async () => {
        const config = await checkSiteConfig(apiData, siteData.id, dispatch)
        console.log(config);
        _setSupportsCamect(config[0].supportsCamect)

        if (config[1].supportsMonitoredBy == 1 || isAllowed){
          setShowMonitoredBy(true)
        }
        
        if (config[0].supportsCamect == 1) {
          setCamectIntegrationType(siteData.camectIntegrationType == "1" ? "Whole camect" : "Per camera arming")
          setIsLoading(false)
        } else {
          setShowCCTVIntegration(false)
        }
      }

      const ListPartneredArcs = async () => {
          const response = await listPartneredArcs(apiData, dispatch)
          const partneredArcsWithSelf = [
            { id: 0, name: 'Self monitored' },
            ...response.data
          ];
          
          const filteredPartneredArcs = partneredArcsWithSelf.filter(arc => arc.name != "Monitor Test" && arc.name != "Monitor Test 2")

          //This is for the UI - to display the current monitoredBy
          setMonitoredByOptions(filteredPartneredArcs)
          const monitoredByName = partneredArcsWithSelf.find(arc => arc.id == siteData.monitoredBy)?.name
          if (monitoredByName){ //If its not null
            setMonitoredBy(monitoredByName)
          } else {
            setMonitoredBy("Self monitored")
          }
          setIsLoadingArc(false)
      }

      const checkSiteRestriction = async () => {

          const response = await checkAccessRestrictions(siteData.uuid, apiData, dispatch)
          if (response.success){
            if (response.data.length > 0 && response.data[0].startTime && response.data[0].endTime){
              setAccessRestrictions(`Available between ${response.data[0].startTime} and ${response.data[0].endTime}`)
            } else {
              setAccessRestrictions(`None`)
            }
          }
          
          setIsLoadingRestriction(false)
      }

      const ListLiveViewCameras = async () => {
        const response = await getLiveViewCameras(apiData, siteData.uuid)
        if (response.success){
          setLiveViewCameras(response.data)
          setLiveViewCameraCount(response.data.length)
        }
      }

      CheckSiteConfig();
      ListPartneredArcs();
      checkSiteRestriction();
      if (siteData.liveViewEnabled){
        ListLiveViewCameras();
      }
    }, [])


    if (ipAddress == "10.250.20.173") {
            IP = "Server 1"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.20.155") {
            IP = "Server 2"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.20.175") {
            IP = "Server 3"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.20.165") {
            IP = "Server 4"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.20.224") {
            IP = "Server 5"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.20.98") {
            IP = "Server 6"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.20.184") {
            IP = "Server 7"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.20.130") {
            IP = "Server 8"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.20.21") {
            IP = "Server 9"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.1.22") {
            IP = "Upgrade Server"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.1.64") {
            IP = "FW Dev Server"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.20.178") {
            IP = "Server 10"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "10.250.20.8") {
            IP = "Davantis"
            showIP = false
            type = `Virtual iON (${IP})`
          } else if (ipAddress == "TypeS") {
            IP = "Ajax/Dahua/Ganz";
            showIP = false
            type = `Virtual iON (G2CC)`
          } else {
            IP = ipAddress
            
          }

          if (sitetype == "AB"){
            if (firmware == "1.7.14" || firmware == "1.7.15"){
              type = "iON (BPi)"
            } else if (firmware == "1.9.10"){
              type = "iON (RCK)"
            } else {
              type = "iON (RPi)"
            }
          } else if (sitetype == "ESP"){
            type = "iON"
          } else if (sitetype == "S"){
            type = "Virtual"
          }

    const setMonitoringArc = async (arc) => {
      if (arc.platform === 'smtp') {
        setPendingArc(arc)
        setShowImmixDialog(true)
      }
      else if (arc.platform === 'immix') {
        setPendingArc(arc)
        setImmixAddress((siteData.immixAddress != "" && siteData.immixAddress != null) ? siteData.immixAddress : "")
        setShowImmixAddressDialog(true)
      }
      else {
        const body = {
          "siteUUID": siteData.uuid,
          "arcID": arc.id
        }
        const response = await setArc(apiData, body, dispatch)
        if (response.success) {
          setMonitoredBy(arc.name)
          successModal("Arc successfully updated")
        } else {
          errorModal("Failed to update arc, please try again")
        }
      }
    }

    const confirmImmixArc = async () => {
      const existingArc = monitoredByOptions.find(arc => arc.name === monitoredBy)
      const arcID = pendingArc ? pendingArc.id : existingArc?.id
      const arcName = pendingArc ? pendingArc.name : monitoredBy
      const body = {
        "siteUUID": siteData.uuid,
        "arcID": arcID,
        "smtpToAddress": smtpToEmail,
        "smtpFromAddress": smtpFromEmail,
        "smtpUsername": smtpUsername,
        "smtpPassword": smtpPassword
      }
      const response = await setArc(apiData, body, dispatch)
      if (response.success) {
        setMonitoredBy(arcName)
        setSiteData(prev => ({ ...prev, smtpToAddress: smtpToEmail, smtpFromAddress: smtpFromEmail, smtpUsername: smtpUsername, smtpPassword: smtpPassword }))
        successModal("Arc successfully updated")
        setShowImmixDialog(false)
        setPendingArc(null)
        setSmtpToEmail("")
        setSmtpFromEmail("")
        setSmtpUsername("")
        setSmtpPassword("")
      } else {
        errorModal("Failed to update arc, please try again")
      }
    }

    const confirmImmixAddressArc = async () => {
      const existingArc = monitoredByOptions.find(arc => arc.name === monitoredBy)
      const arcID = pendingArc ? pendingArc.id : existingArc?.id
      const arcName = pendingArc ? pendingArc.name : monitoredBy
      const body = {
        "siteUUID": siteData.uuid,
        "arcID": arcID
      }
      const response = await setArc(apiData, body, dispatch)
      if (response.success) {
        const detailsBody = {
          siteUUID: siteData.uuid,
          columnName: "immixAddress",
          newValue: immixAddress
        }
        await updateSiteDetails(apiData, detailsBody, dispatch)
        setSiteData(prev => ({ ...prev, immixAddress: immixAddress }))
        setMonitoredBy(arcName)
        successModal("Arc successfully updated")
        setShowImmixAddressDialog(false)
        setPendingArc(null)
        setImmixAddress("")
      } else {
        errorModal("Failed to update arc, please try again")
      }
    }

    const setSiteLocation = async (newLocale) => {
      const body = {
        "siteUUID": siteData.uuid, 
        "columnName": "country_code",
        "newValue": newLocale 
      }

      const response = await updateSiteDetails(apiData, body, dispatch)
    }

    const setSiteLocationType = async (newType) => {
      const body = {
        "siteUUID": siteData.uuid, 
        "columnName": "site_type",
        "newValue": newType 
      }

      const response = await updateSiteDetails(apiData, body, dispatch)
    }



    const HandleChangeSiteActive = async (newState) => {
      HandleCloseModal();
      const newStateText = newState == false ? "disable" : "enable"
      let body = {
        "uuid": siteData.uuid,
        "active": newState == false ? 0 : 1
      }

      const response = await setSiteActive(apiData, body, dispatch)
      if (response.success){
        successModalWithReload(`Site successfully ${newStateText}d`)
        setSwitchState(newState == false ? 0 : 1)
      } else {
        errorModal(`Failed to ${newStateText} site, please try again`)
      }
    }

    const HandleChangeLiveView = async (newState) => {
      HandleCloseModal();
      const newLiveViewStateText = newState == true ? "enable" : "disable"
      let body = {
        "uuid": siteData.uuid,
        "liveViewEnabled": newState == false ? 0 : 1
      }

      const response = await setSiteLiveView(apiData, body, dispatch)
      if (response.success){
        successModalWithReload(`Live View successfully ${newLiveViewStateText}d`)
        setLiveViewSwitchState(newState == false ? 0 : 1)
      } else {
       errorModal(`Failed to ${newLiveViewStateText} Live View, please try again`)
     }
    }

    const HandleChangeScheduleOnly = async (newState) => {
      HandleCloseModal();
      const newScheduleOnlytateText = newState == true ? "enabled" : "disabled"
      const newScheduleOnlytateText2 = newState == true ? "enable" : "disable"

      let body = {
        "uuid": siteData.uuid,
        "scheduleOnly": newState == false ? 0 : 1
      }

      const response = await setScheduleOnly(apiData, body, dispatch)
      if (response.success){
        successModal(`Schedule only successfully ${newScheduleOnlytateText}`)
        setScheduleOnlySwitchState(newState == false ? 0 : 1)
      } else {
       errorModal(`Failed to ${newScheduleOnlytateText2} schedule only, please try again`)
     }
    }

    const HandleChangeSnapshotEnabled = async (newState) => {
      HandleCloseModal();
      const newSnapshotEnabledStateText = newState == true ? "enabled" : "disabled"
      const newSnapshotEnabledStateText2 = newState == true ? "enable" : "disable"

      const body = {
        siteUUID: siteData.uuid,
        columnName: "snapshotEnabled",
        newValue: newState == false ? 0 : 1
      }

      const response = await updateSiteDetails(apiData, body, dispatch)
      if (response.success){
        successModalWithReload(`Snapshot on demand successfully ${newSnapshotEnabledStateText}`)
        setSnapshotEnabledSwitchState(newState == false ? 0 : 1)
      } else {
       errorModal(`Failed to ${newSnapshotEnabledStateText2} snapshot on demand, please try again`)
     }
    }

    useEffect(() => {
      if (unauthotisedClick) {
        toast.current.show({ severity: 'error', summary: 'Unauthorised', detail: 'Please contact your administrator to update billing for this site', life: 3000 })
        setUnauthorisedClick(false)
      }
    }, [unauthotisedClick])

    const UpdateSiteDetails = async (columnName, newValue) => {
        const body = {
            siteUUID: siteData.uuid,
            columnName: columnName,
            newValue: newValue
        }
        const response = await updateSiteDetails(apiData, body, dispatch)
        if (response.success) {
            setSiteData(prev => ({ ...prev, [columnName]: newValue }))
        }
        return response
    }

    const [selectedBillable, setSelectedBillable] = useState(null)
    const billableOptions = [
        { label: 'Yes (Billable)', value: 1 },
        { label: 'No (Not billable)', value: 0 },
        { label: 'Demo', value: 2 },
    ]

    const acceptBillable = async () => {
        if (selectedBillable === null) return
        await UpdateSiteDetails("billable", selectedBillable)
        setChangeBillable(false)
        setSelectedBillable(null)
        successModal("Billing status updated")
        await offerPropagation("billable", selectedBillable)
    }

    const updateBilledTo = async () => {
        const newBilledToID = groups?.find(g => g.name === newBilledToGroupName)?.id
        await UpdateSiteDetails("billedToGID", newBilledToID)
        setSiteData(prev => ({ ...prev, billedToGID: newBilledToID }))
        successModal("Billed to updated")
        setChangeBilledTo(false)
        await offerPropagation("billedToGID", newBilledToID)
    }

    const updateCustomerBilledTo = async () => {
        const newCustomerBilledToID = groups?.find(g => g.name === newCustomerBilledToGroupName)?.id
        if (!newCustomerBilledToID) return
        await UpdateSiteDetails("customerBilledToGID", newCustomerBilledToID)
        setSiteData(prev => ({ ...prev, customerBilledToGID: newCustomerBilledToID }))
        successModal("Customer billed to updated")
        setChangeCustomerBilledTo(false)
    }

    const updateBillingFrequency = async () => {
        await UpdateSiteDetails("billingFrequency", newBillingFrequency)
        setSiteData(prev => ({ ...prev, billingFrequency: newBillingFrequency }))
        successModal("Billing frequency updated")
        setChangeBillingFrequency(false)
        await offerPropagation("billingFrequency", newBillingFrequency)
    }

    const updateDateOfFirstInvoice = async () => {
        const formattedDate = newDateOfFirstInvoice ? format(newDateOfFirstInvoice, "yyyy-MM-dd") : ""
        await UpdateSiteDetails("firstInvoiceDate", formattedDate)
        setSiteData(prev => ({ ...prev, firstInvoiceDate: formattedDate }))
        successModal("Invoice date updated")
        setChangeDateOfFirstInvoice(false)
        await offerPropagation("firstInvoiceDate", formattedDate)
    }

    const updateDateOfLastInvoice = async () => {
      const formattedDate = newDateOfLastInvoice ? format(newDateOfLastInvoice, "yyyy-MM-dd") : ""
      await UpdateSiteDetails("lastInvoiceDate", formattedDate)
      setSiteData(prev => ({ ...prev, lastInvoiceDate: formattedDate }))
      successModal("Invoice date updated")
      setChangeDateOfLastInvoice(false)
      await offerPropagation("lastInvoiceDate", formattedDate)
  }

    const updateDateMadeActive = async () => {
        const formattedDate = newDateMadeActive ? format(newDateMadeActive, "yyyy-MM-dd") : ""
        await UpdateSiteDetails("dateMadeActive", formattedDate)
        successModal("Date made active updated")
        setChangeDateMadeActive(false)
    }

  const suspendSite = () => {
    setShowSuspendPopup(false)
    setShowSuspendSite(true)
  };

    const openEmbeddedURLDialog = () => {
        setEditEmbeddedURL(siteData.embeddedURL || "")
        setEditEmbeddedURLTitle(siteData.embeddedURLTitle || "")
        setShowEmbeddedURLDialog(true)
    }

    const saveEmbeddedURL = async () => {
        const body = {
            uuid: siteData.uuid,
            embeddedURL: editEmbeddedURL,
            embeddedURLTitle: editEmbeddedURLTitle
        }
        console.log(body);
        const response = await setEmbeddedURL(apiData, body, dispatch)
        if (response.success) {
            setSiteData(prev => ({ ...prev, embeddedURL: editEmbeddedURL, embeddedURLTitle: editEmbeddedURLTitle }))
            setShowEmbeddedURLDialog(false)
            successModal("Embedded URL updated")
        } else {
            errorModal("Failed to update embedded URL, please try again")
        }
    }

    const changeNotificationState = async () => {
      const body = {
        uuid: uuid,
        active: notificationsEnabled == true ? 0 : 1
      }
      
      const response = await setSiteNotififcations(apiData, body, dispatch)
      if (response.success){
        successModal('Notifications updated')
        setNotificationsEnabled(prev => !prev)
        setShowChangeNotificationState(false)
      } else {
        errorModal('Failed to update notifications, please try again')
        setShowChangeNotificationState(false)
      }
    }

    useEffect(() => {
        if (device[1].tag !== siteData.tag) {
            setSiteData(prev => ({ ...prev, tag: device[1].tag }));
        }
    }, [device[1].tag])

    useEffect(() => {
    }, [switchState])

  

    const showConfirmActivePopup= () => {
      if (switchState == 0) {
        const owningGroup = groups?.find(g => g.name === siteData.name)
        if (!owningGroup?.billingEnabled && companyName !== "EyeSpyFX") {
          setModalTitle("Account setup required")
          setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "12px", maxWidth: "480px" }}>
              <p style={{ textAlign: "center", color: "#858585", fontSize: "15px", margin: 0 }}>
                Unfortunately you are unable to make this site active as your company has not yet properly set up an account with Inniovate.
              </p>
              <p style={{ textAlign: "center", color: "#858585", fontSize: "15px", margin: 0 }}>
                If your company has not yet formally set up an account with us, please do so here:<br/>
                <a href="https://inniovate.com/account-setup" target="_blank" rel="noreferrer" style={{ color: "rgb(41,140,182)" }}>https://inniovate.com/account-setup</a>
              </p>
              <p style={{ textAlign: "center", color: "#858585", fontSize: "15px", margin: 0 }}>
                If you have set up an account, but have not set up Direct Debit, please click on this link to set up your company's Direct Debit:<br/>
                <a href="https://pay.gocardless.com/BRT0002ZAC41XYA" target="_blank" rel="noreferrer" style={{ color: "rgb(41,140,182)" }}>https://pay.gocardless.com/BRT0002ZAC41XYA</a>
              </p>
              <p style={{ textAlign: "center", color: "#858585", fontSize: "15px", margin: 0 }}>
                Please make contact with your Inniovate sales representative if you are unable to set this up or have any queries.
              </p>
              <br/>
              <div className={classes.buttons}>
                <Button icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity="secondary" />
              </div>
            </div>
          )
          HandleShowModal();
          return;
        }

        if (siteData.tag === "") {
          setModalTitle("Portal name required")
          setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
              <p style={{ textAlign: "center", color: "#858585", fontSize: "15px" }}>A portal site name must be set before this site can be activated.</p>
              <br/>
              <div className={classes.buttons}>
                <Button icon="pi pi-times" onClick={HandleCloseModal} label="Cancel" severity="secondary" />
                <Button icon="pi pi-pencil" onClick={() => { HandleCloseModal(); setShowChangePortalName(true); setPendingActive(true); }} label="Set portal name" severity="success" />
              </div>
            </div>
          )
          HandleShowModal();
          return;
        }
      }

      const newStateText = switchState == 1 ? "disable" : "enable"
        setModalTitle("Are you sure?")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <Lottie animationData={areYouSureAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
          <div>
            <br/>
              <h3 style={{ textAlign: "center", color:"#858585"}}>{`${switchState == 0  ? "Billing will commence for this site from now on. Are you sure you want to make it active? " : "Are you sure you want to disable this site?"}`}</h3>
          </div>   
          <br></br>
          <br></br>
          <div>
            <div className={classes.buttons}> 
              <Button icon="pi pi-times" onClick={HandleCloseModal} label="No, cancel" severity='secondary'/>
              <Button icon="pi pi-check" onClick={() => HandleChangeSiteActive(switchState == 0 ? 1 : 0)} label="Yes" severity='danger'/>
            </div>
          </div>
        </div>
        )

        HandleShowModal();
    }

    const showConfirmLiveViewPopup= () => {
      if (isAllowed){
      const newStateText = liveViewSwitchState == 1 ? "disable" : "enable"
        setModalTitle("Are you sure?")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <Lottie animationData={areYouSureAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
          <div>
            <br/>
              <h3 style={{ textAlign: "center", color:"#858585"}}>{`Are you sure you want to ${newStateText} live view for this site?`}</h3>
              {/* <h4 style={{ textAlign: "center", color:"#858585"}}>{`Please note this will disable the site for all users and prevent schedules & reminders from executing`}</h4> */}
          </div>   
          <br></br>
          <br></br>
          <div>
            <br></br>
            <div className={classes.buttons}> 
              <Button icon="pi pi-times" onClick={HandleCloseModal} label="No, cancel" severity='secondary'/>
              <Button icon="pi pi-check"  onClick={() => HandleChangeLiveView(liveViewSwitchState == 0 ? 1 : 0)} label="Yes" severity='danger'/>
            </div>
          </div>
        </div>
        )

        HandleShowModal();
      } else {
          toast.current.show({ severity: 'error', summary: 'Unauthorsied', detail: 'Please contact your administrator to update live view for this site', life: 3000 });
      }
    }


    const showConfirmScheduleOnlyPopup= () => {
      if (isAllowed){
      const newStateText = scheduleOnlySwitchState == 1 ? "disable" : "enable"
        setModalTitle("Are you sure?")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <Lottie animationData={areYouSureAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
          <br/>
          <div>

              <h3 style={{ textAlign: "center", color:"#858585"}}>{`Are you sure you want to ${newStateText} schedule only for this site?`}</h3>
              <h4 style={{ textAlign: "center", color:"#858585"}}>{`Please note this will disable the ability to add users and only allow schedules to execute`}</h4>
          </div>   
          <br></br>
          <br></br>
          <div>
            <br></br>
            <div className={classes.buttons}> 
              <Button icon="pi pi-times"  onClick={HandleCloseModal} label="No, cancel" severity='secondary'/>
              <Button icon="pi pi-check"  onClick={() => HandleChangeScheduleOnly(scheduleOnlySwitchState == 0 ? 1 : 0)} label="Yes" severity='danger'/>       
          </div>
            
          </div>
        </div>
        )

        HandleShowModal();
      } else {
          toast.current.show({ severity: 'error', summary: 'Unauthorsied', detail: 'Please contact your administrator to update schedule only for this site', life: 3000 });
      }
    }

    const showConfirmSnapshotEnabledPopup= () => {
      if (isEyeSpyFXOnly){
      const newStateText = snapshotEnabledSwitchState == 1 ? "disable" : "enable"
        setModalTitle("Are you sure?")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <Lottie animationData={areYouSureAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
          <br/>
          <div>

              <h3 style={{ textAlign: "center", color:"#858585"}}>{`Are you sure you want to ${newStateText} snapshot on demand for this site?`}</h3>
              <h4 style={{ textAlign: "center", color:"#858585"}}>{`Please note this will ${newStateText} the ability to use snapshot as an option in the rule wizard`}</h4>
          </div>
          <br></br>
          <br></br>
          <div>
            <br></br>
            <div className={classes.buttons}>
              <Button icon="pi pi-times"  onClick={HandleCloseModal} label="No, cancel" severity='secondary'/>
              <Button icon="pi pi-check"  onClick={() => HandleChangeSnapshotEnabled(snapshotEnabledSwitchState == 0 ? 1 : 0)} label="Yes" severity='danger'/>
          </div>

          </div>
        </div>
        )

        HandleShowModal();
      } else {
          toast.current.show({ severity: 'error', summary: 'Unauthorsied', detail: 'Please contact your administrator to update snapshot on demand for this site', life: 3000 });
      }
    }

    return (
      <>
      <Toast ref={toast} />
      
      <Modal ref={ModalDialog} title={modalTitle} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "600px", minHeight: modalPageIndex === 1 ? "665px" : "250px"}} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
      </Modal>

            <Dialog
                header="Update billing status"
                visible={changeBillable}
                style={{ width: '30vw' }}
                onHide={() => { setChangeBillable(false); setSelectedBillable(null); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Dropdown
                        placeholder="Select status"
                        options={billableOptions}
                        optionLabel="label"
                        optionValue="value"
                        value={selectedBillable}
                        onChange={(e) => setSelectedBillable(e.value)}
                    />
                </div>
                <br />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <Button icon="pi pi-times" label="Cancel" onClick={() => { setChangeBillable(false); setSelectedBillable(null); }} className="p-button-secondary" />
                    <Button icon="pi pi-save" label="Save" onClick={acceptBillable} disabled={selectedBillable === null} />
                </div>
            </Dialog>

            <Dialog
                header="Select new purchasee"
                visible={changeBilledTo}
                style={{ width: '30vw', height: '25vw' }}
                onHide={() => { if (!changeBilledTo) return; setChangeBilledTo(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex: 1201 }}>
                    <Dropdown
                        placeholder={newBilledToGroupName}
                        options={groups?.map((group) => group.name).sort((a, b) => a.localeCompare(b))}
                        onChange={(e) => setNewBilledToGroupName(e.value)}
                        filter
                        appendTo="self"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times"  label="Cancel" onClick={() => setChangeBilledTo(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save"  label="Save" onClick={updateBilledTo} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Select customer billed to"
                visible={changeCustomerBilledTo}
                style={{ width: '30vw', height: '25vw' }}
                onHide={() => { if (!changeCustomerBilledTo) return; setChangeCustomerBilledTo(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex: 1201 }}>
                    <Dropdown
                        placeholder={newCustomerBilledToGroupName || "Select group"}
                        options={groups?.map((group) => group.name).sort((a, b) => a.localeCompare(b))}
                        onChange={(e) => setNewCustomerBilledToGroupName(e.value)}
                        filter
                        appendTo="self"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeCustomerBilledTo(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateCustomerBilledTo} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Select new billing frequency"
                visible={changeBillingFrequency}
                style={{ width: '30vw', height: '20vw' }}
                onHide={() => { if (!changeBillingFrequency) return; setChangeBillingFrequency(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', zIndex: 1201 }}>
                    <Dropdown
                        placeholder={newBillingFrequency}
                        options={billingOptions}
                        onChange={(e) => setNewBillingFrequency(e.value)}
                    />
                </div>
                <br />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <Button icon="pi pi-times"  label="Cancel" onClick={() => setChangeBillingFrequency(false)} className="p-button-secondary" />
                    <Button icon="pi pi-save"  label="Save" onClick={updateBillingFrequency} />
                </div>
            </Dialog>

            <Dialog
                header="Set date of hardware invoice"
                visible={changeDateOfFirstInvoice}
                style={{ width: '30vw' }}
                onHide={() => { if (!changeDateOfFirstInvoice) return; setChangeDateOfFirstInvoice(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Calendar
                        value={newDateOfFirstInvoice}
                        onChange={(e) => setNewDateOfFirstInvoice(e.value)}
                        dateFormat="dd/mm/yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times"  label="Cancel" onClick={() => setChangeDateOfFirstInvoice(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save"  label="Save" onClick={updateDateOfFirstInvoice} disabled={!newDateOfFirstInvoice} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Set date of 1st SaaS invoice"
                visible={changeDateOfLastInvoice}
                style={{ width: '30vw' }}
                onHide={() => { if (!changeDateOfLastInvoice) return; setChangeDateOfLastInvoice(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Calendar
                        value={newDateOfFirstInvoice}
                        onChange={(e) => setNewDateOfLastInvoice(e.value)}
                        dateFormat="dd/mm/yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times"  label="Cancel" onClick={() => setChangeDateOfLastInvoice(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save"  label="Save" onClick={updateDateOfLastInvoice} disabled={!newDateOfLastInvoice} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Set date made active"
                visible={changeDateMadeActive}
                style={{ width: '30vw' }}
                onHide={() => { if (!changeDateMadeActive) return; setChangeDateMadeActive(false); }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Calendar
                        value={newDateMadeActive}
                        onChange={(e) => setNewDateMadeActive(e.value)}
                        dateFormat="dd/mm/yy"
                        showIcon
                        inline
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button icon="pi pi-times" label="Cancel" onClick={() => setChangeDateMadeActive(false)} className="p-button-secondary" />
                        <Button icon="pi pi-save" label="Save" onClick={updateDateMadeActive} disabled={!newDateMadeActive} />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header={`${notificationsEnabled == true ? "Disable" : "Enable"} site notifications`}
                visible={showChangeNotificationState}
                style={{ width: '30vw', height: 'fit-content' }}
                onHide={() => { if (!showChangeNotificationState) return; setShowChangeNotificationState(false); }}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                
                    <Lottie
                        animationData={areYouSureAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff", textAlign:'center' }}>{`Are you sure you want to ${notificationsEnabled == true ? "disable" : "enable"} notifications for this site?`}</h3>
                    <br />
                    <div className={classes.buttons}> 
                        <Button icon="pi pi-times" label="No, cancel" onClick={() => setShowChangeNotificationState(false)} className="p-button-secondary" style={{marginBottom:"0px"}}/>
                        <br/>
                        <Button icon="pi pi-check"  label="Yes" severity='danger' onClick={changeNotificationState} />
                    </div>

                </div>
            </Dialog>

            <Dialog
                header={`${siteData.status != "available" ? "Unsuspend" : "Suspend"} site`}
                visible={showSuspendPopup}
                style={{ width: '30vw' }}
                onHide={() => setShowSuspendPopup(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={areYouSureAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff", textAlign:'center' }}>{`Are you sure you want to ${siteData.status != "available" ? "unsuspend" : "suspend"} this site?`}</h3>
                    <br />

                    <div className={classes.buttons}> 
                    <Button icon="pi pi-times"  label="No, cancel" onClick={() => setShowSuspendPopup(false)} className="p-button-secondary" style={{ width: '125px' }} />
                    <br />
                    <Button icon="pi pi-check"  label="Yes" severity='danger' onClick={suspendSite} style={{ width: '125px' }}  />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="SMTP configuration"
                visible={showImmixDialog}
                style={{ width: '35vw' }}
                onHide={() => {
                    setShowImmixDialog(false)
                    setPendingArc(null)
                    setSmtpToEmail("")
                    setSmtpFromEmail("")
                    setSmtpUsername("")
                    setSmtpPassword("")
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                        <label style={{ color: '#6e6e6e', fontSize: '14px' }}>SMTP to email</label>
                        <InputText value={smtpToEmail} onChange={(e) => setSmtpToEmail(e.target.value)} placeholder="to@example.com" />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                        <label style={{ color: '#6e6e6e', fontSize: '14px' }}>SMTP from email</label>
                        <InputText value={smtpFromEmail} onChange={(e) => setSmtpFromEmail(e.target.value)} placeholder="from@example.com" />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                        <label style={{ color: '#6e6e6e', fontSize: '14px' }}>SMTP username</label>
                        <InputText value={smtpUsername} onChange={(e) => setSmtpUsername(e.target.value)} placeholder="Username" />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                        <label style={{ color: '#6e6e6e', fontSize: '14px' }}>SMTP password</label>
                        <InputText value={smtpPassword} onChange={(e) => setSmtpPassword(e.target.value)} placeholder="Password" />
                    </div>
                </div>
                <br />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <Button icon="pi pi-times" label="Cancel" onClick={() => { setShowImmixDialog(false); setPendingArc(null); }} className="p-button-secondary" />
                    <Button
                        icon="pi pi-save"
                        label="Save"
                        onClick={confirmImmixArc}
                        disabled={!smtpToEmail || !smtpFromEmail || !smtpUsername || !smtpPassword}
                    />
                </div>
            </Dialog>

            <Dialog
                header="Immix configuration"
                visible={showImmixAddressDialog}
                style={{ width: '35vw' }}
                onHide={() => {
                    setShowImmixAddressDialog(false)
                    setPendingArc(null)
                    setImmixAddress("")
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                        <label style={{ color: '#6e6e6e', fontSize: '14px' }}>Immix address</label>
                        <InputText value={immixAddress} onChange={(e) => setImmixAddress(e.target.value)} placeholder="Immix address" />
                    </div>
                </div>
                <br />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <Button icon="pi pi-times" label="Cancel" onClick={() => { setShowImmixAddressDialog(false); setPendingArc(null); }} className="p-button-secondary" />
                    <Button
                        icon="pi pi-save"
                        label="Save"
                        onClick={confirmImmixAddressArc}
                        disabled={!immixAddress}
                    />
                </div>
            </Dialog>

            <Dialog
                header="Set embedded URL"
                visible={showEmbeddedURLDialog}
                style={{ width: '35vw' }}
                onHide={() => setShowEmbeddedURLDialog(false)}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                        <label style={{ color: '#6e6e6e', fontSize: '14px' }}>URL</label>
                        <InputText value={editEmbeddedURL} onChange={(e) => setEditEmbeddedURL(e.target.value)} placeholder="https://example.com" />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                        <label style={{ color: '#6e6e6e', fontSize: '14px' }}>URL Title</label>
                        <InputText value={editEmbeddedURLTitle} onChange={(e) => setEditEmbeddedURLTitle(e.target.value)} placeholder="e.g. Dashboard" />
                    </div>
                </div>
                <br />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                    <Button icon="pi pi-times" label="Cancel" onClick={() => setShowEmbeddedURLDialog(false)} className="p-button-secondary" />
                    <Button icon="pi pi-save" label="Save" onClick={saveEmbeddedURL} />
                </div>
            </Dialog>

            <Dialog
                header="Apply to connected devices?"
                visible={showPropagateDialog}
                style={{ width: '420px' }}
                onHide={() => { setShowPropagateDialog(false); setPendingPropagation(null); }}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                        <Button label="Skip" icon="pi pi-times" severity="secondary" outlined onClick={() => { setShowPropagateDialog(false); setPendingPropagation(null); }} />
                        <Button label="Apply to all" icon="pi pi-check" severity="success" loading={isPropagating} onClick={propagateBillingChange} />
                    </div>
                }
            >
                <p style={{ margin: '0 0 12px 0', color: '#6e6e6e', fontSize: '14px' }}>
                    Would you like to apply this billing change to all {connectedDeviceCount(connectedDevices)} connected device{connectedDeviceCount(connectedDevices) !== 1 ? 's' : ''} on this site too?
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '13px', color: '#9e9e9e' }}>
                    {connectedDevices?.gateways?.length > 0 && <span>{connectedDevices.gateways.length} gateway{connectedDevices.gateways.length !== 1 ? 's' : ''}</span>}
                    {connectedDevices?.sensors?.length > 0 && <span>{connectedDevices.sensors.length} sensor{connectedDevices.sensors.length !== 1 ? 's' : ''}</span>}
                    {connectedDevices?.iglooLocks?.length > 0 && <span>{connectedDevices.iglooLocks.length} padlock{connectedDevices.iglooLocks.length !== 1 ? 's' : ''}</span>}
                </div>
            </Dialog>

        <div>

          <div className={classes.switchContainer}>
            {(role === "admin" || role === "TechSupport") && <p style={{marginLeft:"2px", fontWeight:"500", fontSize:"18px", color:"#808080"}}>{"Active site"}</p>}
            {(role === "admin" || role === "TechSupport") && <InputSwitch checked={switchState == 1 ? true : false} onChange={showConfirmActivePopup} />}

            <p style={{marginLeft:"10px", fontWeight:"500", fontSize:"18px", color:"#808080", opacity: !isEyeSpyFXOnly ? 0.5 : 1.0}}>{"Live view"}</p>
            <InputSwitch style={{ opacity: !isEyeSpyFXOnly ? 0.5 : 1.0 }} disabled={!isEyeSpyFXOnly} checked={liveViewSwitchState == 1 ? true : false} onChange={showConfirmLiveViewPopup} />
          
            {isAllowed && <p style={{marginLeft:"10px", fontWeight:"500", fontSize:"18px", color:"#808080", opacity: !isAllowed ? 0.5 : 1.0}}>{"Schedule only"}</p>}
            {isAllowed && <InputSwitch style={{ opacity: !isAllowed ? 0.5 : 1.0 }} checked={scheduleOnlySwitchState == 1 ? true : false} onChange={showConfirmScheduleOnlyPopup} />}

            <p style={{marginLeft:"10px", fontWeight:"500", fontSize:"18px", color:"#808080", opacity: !isEyeSpyFXOnly ? 0.5 : 1.0}}>{"Snapshot on demand"}</p>
            <InputSwitch style={{ opacity: !isEyeSpyFXOnly ? 0.5 : 1.0 }} disabled={!isEyeSpyFXOnly} checked={snapshotEnabledSwitchState == 1 ? true : false} onChange={showConfirmSnapshotEnabledPopup} />
          </div>

          <p style={{marginLeft:"2px", marginTop:"10px", fontWeight:"500", fontSize:"20px", color:"#808080"}}>{(role === "admin" || role === "TechSupport") ? "Settings" : "Information"}</p>
          {(role === "admin" || role === "TechSupport") && <p style={{marginLeft:"2px", fontWeight:"400", fontSize:"16px", color:"#808080"}}>Click on the tiles to modify settings</p>}

          <div className={classes.container}>
              <Stats2 title={"Portal site name"} value={portalSiteName} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangePortalName={setShowChangePortalName} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} />
              <Stats2 title={"My app site name"} value={myAppSiteName} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeName={setShowChangeName} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} />    
              <Stats2 title={"Serial number"} value={serialNumber} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={role === "admin" || role === "TechSupport"}/>
              <Stats2 title={"Group"} value={group} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeGroup={setShowChangeGroup} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} />

              <Stats2 title={"Suspended"} value={suspended} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowSuspendSite={setShowSuspendPopup} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} />

              {( showCCTVIntegration && <Stats2 title={"CCTV integration type"} value={camectIntegrationType} status={""} isLoadingStats={isLoading} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeCCTV={setShowChangeCCTV} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} />)}
              <Stats2 title={"Site location"} value={countryCodeOptions.find(c => c.code === countryCode)?.name ?? countryCode} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangePortalName={setShowChangePortalName} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} countryCodeOptions={countryCodeOptions} countryCode={countryCode} setCountryCode={setCountryCode} showCountryDropdown={showCountryDropdown} setShowCountryDropdown={setShowCountryDropdown} setSiteLocation={setSiteLocation}/>
              <Stats2 title={"Site type"} value={siteType} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangePortalName={setShowChangePortalName} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} siteType={siteType} setSiteType={setSiteType} showSiteTypeDropdown={showSiteTypeDropdown} setShowSiteTypeDropdown={setShowSiteTypeDropdown} siteTypeOptions={siteTypeOptions} setSiteLocationType={setSiteLocationType}/>
              <Stats2 title={"Site notifications"} value={notificationsEnabled == true ? "Enabled" : "Disabled"} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangePortalName={setShowChangePortalName} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} siteType={siteType} setSiteType={setSiteType} showSiteTypeDropdown={showSiteTypeDropdown} setShowSiteTypeDropdown={setShowSiteTypeDropdown} siteTypeOptions={siteTypeOptions} setSiteLocationType={setSiteLocationType} setNotificationsState={setShowChangeNotificationState}/>
              <Stats2 title={"Embedded URL"} value={embeddedURLTitle} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangePortalName={setShowChangePortalName} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} siteType={siteType} setSiteType={setSiteType} showSiteTypeDropdown={showSiteTypeDropdown} setShowSiteTypeDropdown={setShowSiteTypeDropdown} siteTypeOptions={siteTypeOptions} setSiteLocationType={setSiteLocationType} setNotificationsState={setShowChangeNotificationState} setShowEmbeddedURL={openEmbeddedURLDialog}/>
              {(showMonitoredBy && <Stats2 title={"Monitored by"} value={monitoredBy} status={""} isLoadingStats={isLoadingArc} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setMonitoringArc={setMonitoringArc} setShowChangeSerialNumber={setShowChangeSerialNumber} editable={role === "admin" || role === "TechSupport"} setShowSmtpDetails={monitoredByOptions.find(arc => arc.name === monitoredBy)?.platform === 'smtp' ? () => { setSmtpToEmail(siteData.smtpToAddress || ""); setSmtpFromEmail(siteData.smtpFromAddress || ""); setSmtpUsername(siteData.smtpUsername || ""); setSmtpPassword(siteData.smtpPassword || ""); setShowImmixDialog(true); } : undefined} setShowImmixDetails={monitoredByOptions.find(arc => arc.name === monitoredBy)?.platform === 'immix' ? () => { setImmixAddress(siteData.immixAddress || ""); setShowImmixAddressDialog(true); } : undefined} />)}

          </div>
      
  
      
          {(role === "admin" || role === "TechSupport") && <p style={{marginLeft:"2px", marginTop:"50px", fontWeight:"500", fontSize:"20px", color:"#808080"}}>Information</p>}
              <div className={classes.container} style={(role !== "admin" && role !== "TechSupport") ? { marginTop: "10px" } : undefined}>
                  <Stats2 title={"Site ID"} value={siteID} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  <Stats2 title={"Firmware"} value={firmware} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  <Stats2 title={"Site type"} value={type} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  {( showIP == true && <Stats2 title={"IP address"} value={IP} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/> )}
                  {( showMac && <Stats2 title={"MAC address"} value={macAddress} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>)}
                  <Stats2 title={"Status"} value={online} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  {(<Stats2 title={"Access restrictions"} value={accessRestrictions} status={""} isLoadingStats={isLoadingRestriction} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeCCTV={setShowChangeCCTV}setShowChangeSerialNumber={setShowChangeSerialNumber}/>)}
                  {( online == "Offline" && <Stats2 title={"Offline since"} value={lastUpdateDate} status={""} isLoadingStats={false} isStatic={true} />)}
                  <Stats2 title={"Created"} value={creationDate} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  {createdBy && <Stats2 title={"Created by"} value={createdBy} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>}
                  {/* {(_supportsCamect == 0 && <Stats2 title={"CCTV integration type"} value={camectIntegrationType} status={""} isLoadingStats={isLoading} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeCCTV={setShowChangeCCTV} />)} */}
                  { siteData.liveViewEnabled == 1 && <Stats2 title={"Linked camera count"} value={liveViewCameraCount} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber} />}
                  <Stats2 title={"No. of users"} value={userCount} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  <Stats2 title={"License type"} value={siteData.scheduleOnly == 1 ? "Schedule only" : "Full license"} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  <Stats2 title={"Live view enabled"} value={siteData.liveViewEnabled == 1 ? "Yes" : "No"} status={""} isLoadingStats={false} isStatic={true} monitoredByOptions={monitoredByOptions} monitoredBy={monitoredBy} setMonitoredBy={setMonitoredBy} showMonitoredByDropdown={showMonitoredByDropdown} setShowMonitoredByDropdown={setShowMonitoredByDropdown} setShowChangeSerialNumber={setShowChangeSerialNumber}/>
                  {siteData.dateMadeActive && siteData.active == 1 && !isAllowed && <Stats2 title={"Active since"} value={new Date(siteData.dateMadeActive).toLocaleDateString('en-GB')} status={""} isLoadingStats={false} isStatic={true} />}
              </div>

            { isAllowed && <p style={{marginLeft:"2px", marginTop:"50px", fontWeight:"500", fontSize:"20px", color:"#808080"}}>Inniovate billing</p>}
            { isAllowed && <div className={classes.container}>
                  <Stats2 title={"Billable"} value={siteData.billable == 1 ? "Yes" : siteData.billable == 2 ? "Demo" : "No"} status={""} isLoadingStats={false} isStatic={true} setChangeBillable={setChangeBillable} isAllowedToChange={true} setUnauthorisedClick={setUnauthorisedClick} editable={true} />
                  {siteData.billable == 1 && <Stats2 title={"Inniovate bill to"} value={groups?.find(g => g.id === siteData.billedToGID)?.name || "Not set"} status={""} isLoadingStats={false} isStatic={true} setChangeBilledTo={setChangeBilledTo} isAllowedToChange={true} editable={true} />}
                  {siteData.billable == 1 && <Stats2 title={"Billing frequency"} value={siteData.billingFrequency != null ? siteData.billingFrequency : "Not set"} status={""} isLoadingStats={false} isStatic={true} setChangeBillingFrequency={setChangeBillingFrequency} isAllowedToChange={true} editable={true} />}
                  <Stats2 title={"Date of hardware invoice"} value={siteData.firstInvoiceDate != null ? new Date(siteData.firstInvoiceDate).toLocaleDateString('en-GB') : "Not set"} status={""} isLoadingStats={false} isStatic={true} setChangeDateOfFirstInvoice={setChangeDateOfFirstInvoice} isAllowedToChange={true} editable={true} />
                  {siteData.billable == 1 && <Stats2 title={"Date of 1st SaaS invoice"} value={siteData.lastInvoiceDate != null ? new Date(siteData.lastInvoiceDate).toLocaleDateString('en-GB') : "Not set"} status={""} isLoadingStats={false} isStatic={true} setChangeDateOfFirstInvoice={setChangeDateOfFirstInvoice} isAllowedToChange={true} setChangeDateOfLastInvoice={setChangeDateOfLastInvoice} editable={true} />}
                  <Stats2 title={"Date made active"} value={siteData.dateMadeActive ? new Date(siteData.dateMadeActive).toLocaleDateString('en-GB') : "Not set"} status={""} isLoadingStats={false} isStatic={true} setChangeDateMadeActive={setChangeDateMadeActive} isAllowedToChange={true} editable={true} />
              </div> }

              {/* RE:SURE ONLY*/ }
              {isCustomerBillingAllowed && <p style={{marginLeft:"2px", marginTop:"50px", fontWeight:"500", fontSize:"20px", color:"#808080"}}>Customer billing</p>}
              {isCustomerBillingAllowed &&
                <div className={classes.container}>
                  <Stats2 title={"RE:SURE bill to"} value={groups?.find(g => g.id === siteData.customerBilledToGID)?.name || "No"} status={""} isLoadingStats={false} isStatic={true} setChangeBilledTo={setChangeCustomerBilledTo} isAllowedToChange={true} editable={true} />
                </div>
              }
          </div>
      </>
    )
}

export default Overview;